import ajax from "@/utils/ajax.js";

export default {
  async getOrdersAsync(input) {
    let response = await ajax.post("/order/GetOrdersAsync", input);
    return response.result;
  },
  async getMemberOrdersForMobileAsync(input) {
    let response = await ajax.post(
      "/order/GetMemberOrdersForMobileAsync",
      input
    );
    return response.result;
  },
  async getMemberOrderForMobileAsync(listNo) {
    let response = await ajax.get(
      `/order/GetMemberOrderForMobileAsync?listNo=${listNo}`
    );
    return response.result;
  },
  async getOrderInfoForMobileAsync(listNo) {
    let response = await ajax.post("/order/GetOrderInfoForMobileAsync", {
      listNo
    });
    return response.result;
  },
  async ticketChangCiChangesAsync(listNo,changCiId,ticketTypeId) {
    let response = await ajax.post("/order/TicketChangCiChangesAsync", {
      listNo,changCiId,ticketTypeId
    });
    return response.result;
  },
  async getOrderOptionsAsync(isGroup, needExplain) {
    let response = await ajax.get(
      `/order/GetOrderOptionsAsync?isGroup=${isGroup}&needExplain=${needExplain}`
    );
    return response.result;
  },
  async getOrderOptionsForBehalfAsync(isGroup, needExplain) {
    let response = await ajax.get(
      `/order/GetOrderOptionsForBehalfAsync?isGroup=${isGroup}&needExplain=${needExplain}`
    );
    return response.result;
  },
  async getOrdersForExplainAsync(input) {
    let response = await ajax.post("/order/GetOrdersForExplainAsync", input);
    return response.result;
  },
  async getGroupOrdersForConsumeAsync(input) {
    let response = await ajax.post("/order/GetGroupOrdersForConsumeAsync", input);
    return response.result;
  },
  async getGroupOrdersForConsumeShouldPageAsync(input) {
    let response = await ajax.post("/order/GetGroupOrdersForConsumeShouldPageAsync", input);
    return response.result;
  },
  async getGroupOrdersBySelfAsync(input) {
    let response = await ajax.post("/order/GetGroupOrdersBySelfAsync", input);
    return response.result;
  },
  async createIndividualOrderAsync(input) {
    return await ajax.post("/order/CreateIndividualOrderAsync", input);
  },
  async createGroupOrderAsync(input) {
    return await ajax.post("order/CreateGroupOrderAsync", input);
  },
  async deliverOrdersOnBehalfAsync(input) {
    return await ajax.post("order/DeliverOrdersOnBehalfAsync", input);
  },
  async deliverOrdersOnBehalfAsync1(input) {
    return await ajax.post("order/DeliverOrdersOnBehalfAsync1", input);
  },
  async enrollOrderAsync(input) {
    return await ajax.post("order/EnrollOrderAsync", input);
  },
  async cancelOrderAsync(listNo) {
    return await ajax.post("/order/CancelOrderAsync", {
      listNo
    });
  },
  async consumeOrderFromMobileAsync(input) {
    return await ajax.post("/order/ConsumeOrderFromMobileAsync", input);
  },
  async checkOutOrderFromMobileAsync(input) {
    return await ajax.post("/order/CheckOutOrderFromMobileAsync", input);
  },
  async statOrdersByTicketTypeAsync(input) {
      let response = await ajax.post("/order/StatOrdersByTicketTypeAsync", input);
      return response.result;
  },
  async statOrdersByTicketTypeForDataCenterAsync(input) {
      let response = await ajax.post("/order/StatOrdersByTicketTypeForDataCenterAsync", input);
      return response.result;
  },
  async statOrderForParkAsync(input) {
    let response = await ajax.post("/order/StatOrderForParkAsync", input);
    return response.result;
  },
  async getTempReservationUrl(yyyyMMddHHmm,explainFlag) {
    let response = await ajax.get(`/order/GetTempReservationUrl?yyyyMMddHHmm=${yyyyMMddHHmm}&explainFlag=${explainFlag}`);
    return response.result;
  },
  async getDailyOrderSurplusQuantityForCustomerAsync(customerId,travelDate,groundId){
    let response = await ajax.get(`/order/GetDailyOrderSurplusQuantityForCustomerAsync?customerId=${customerId}&travelDate=${travelDate}&ticketTypeId=${groundId}`);
    return response.result;
  },
  CreateOrderInput: function() {
    this.travelDate = "";
    this.adultQuantity = 0;
    this.adults = [];
    this.childrenQuantity = 0;
    this.children = [];
    this.groundId = "";
    this.changCiId = "";
    this.contact = {
      mobile: ""
    };
    this.carType = 0;
    this.licensePlateNumber = "";
  }
};
